import React from 'react';
import { Link } from 'react-router-dom';
import { Settings } from 'lucide-react';
import { ProfileHeroLinkedIn } from '../components/ProfileHeroLinkedIn';
import { MatchContext } from '../components/MatchContext';
import { IntentLinks } from '../components/IntentLinks';
import { AgentCapabilities } from '../components/AgentCapabilities';
import { PerformanceMetrics } from '../components/PerformanceMetrics';
import { MarketsServed } from '../components/MarketsServed';
import { ActiveListings } from '../components/ActiveListings';
import { SellerReviews } from '../components/SellerReviews';
export function PublicProfile() {
  return <div className="min-h-screen bg-brand-offwhite font-sans selection:bg-brand-sage selection:text-brand-forest pb-24" data-id="element-777">
      <main data-id="element-778">
        <ProfileHeroLinkedIn data-id="element-779" />
        <MatchContext visible={false} data-id="element-780" />
        <IntentLinks data-id="element-781" />
        <PerformanceMetrics data-id="element-782" />
        <SellerReviews data-id="element-783" />
        <MarketsServed data-id="element-784" />
        <AgentCapabilities data-id="element-785" />
        <ActiveListings data-id="element-786" />
      </main>

      <footer className="py-12 text-center text-sm text-brand-muted" data-id="element-787">
        <p data-id="element-788">© 2026 Eaves Technologies LLC</p>
      </footer>

      {/* Floating Admin Button */}
      <Link to="/admin" className="fixed bottom-6 right-6 bg-brand-dark text-white p-3 rounded-full shadow-premium hover:bg-brand-forest transition-colors z-50 flex items-center justify-center group" aria-label="Admin Dashboard" data-id="element-789">
        <Settings size={24} className="group-hover:rotate-45 transition-transform duration-300" data-id="element-790" />
      </Link>
    </div>;
}